// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QG8x","top":"styles_top__m0G3c","left":"styles_left__1ilrC","description":"styles_description__3rzim"};